import { FacebookFanpage } from '@/components/3rd-party-scripts/facebook-page-client'

import { backendApiFetch } from '@/hooks/backend-api-fetch'

export interface LoginWithFacebookBody {
  accessToken: string
  userID: string
}

export interface FacebookLoginStatusResponse {
  loggedIn: boolean
}

export async function getFacebookLoginStatus() {
  const { data, ok } = await backendApiFetch<FacebookLoginStatusResponse>({
    endpoint: `facebook/status`,
    isProtected: true,
    method: 'GET',
  })
  return { data, ok }
}

export async function loginWithFacebook(body: LoginWithFacebookBody) {
  const { data, ok } = await backendApiFetch({
    endpoint: `facebook/login`,
    isProtected: true,
    body,
    method: 'POST',
  })
  return { data, ok }
}
export async function logoutFacebook() {
  const { data } = await backendApiFetch({
    endpoint: `facebook/logout`,
    isProtected: true,
    method: 'POST',
  })
  return { data }
}

export async function getListFanpages() {
  const { data, ok } = await backendApiFetch<FacebookFanpage[]>({
    endpoint: `facebook/get-fanpages`,
    isProtected: true,
    method: 'POST',
  })
  return { data, ok }
}

export async function linkFanpage(body: any) {
  const { data, ok } = await backendApiFetch({
    endpoint: `facebook/link-fanpage`,
    isProtected: true,
    body,
    method: 'POST',
  })
  return { data, ok }
}

export async function unlinkFanpage(body: any) {
  const { data, ok } = await backendApiFetch({
    endpoint: `facebook/unlink-fanpage`,
    isProtected: true,
    body,
    method: 'POST',
  })
  return { data, ok }
}

export async function verifyToken() {
  const { data, ok } = await backendApiFetch<{ isValid: boolean }>({
    endpoint: `facebook/verify-token`,
    isProtected: true,
    method: 'POST',
  })
  return { data, ok }
}
